var _rect, _path, _rect2, _rect3, _rect4, _rect5, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDonation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 295,
    height: 183,
    viewBox: "0 0 295 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 29,
    height: 30,
    rx: 14.5,
    fill: "#1EB65B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0051 21V19.334H14.2451V12.782H12.3551V11.508C13.4051 11.312 14.1051 11.046 14.7771 10.64H16.3031V19.334H18.2491V21H12.0051Z",
    fill: "#DCF8DB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 35.5,
    y: 3,
    width: 227,
    height: 24,
    rx: 12,
    fill: "#1EB65B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 35.5,
    y: 44,
    width: 135,
    height: 24,
    rx: 12,
    fill: "#E2E2E2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 35.5,
    y: 85,
    width: 75,
    height: 24,
    rx: 12,
    fill: "#E2E2E2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_715_2810",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 268,
    y: 1,
    width: 27,
    height: 27
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 1,
    width: 27,
    height: 27,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_715_2810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.5 24.625C281.181 24.625 280.914 24.5172 280.698 24.3016C280.483 24.0859 280.375 23.8188 280.375 23.5V15.6531C279.175 15.6531 278.022 15.4234 276.916 14.9641C275.809 14.5047 274.834 13.8531 273.991 13.0094C273.147 12.1656 272.5 11.1906 272.05 10.0844C271.6 8.97813 271.375 7.825 271.375 6.625V5.5C271.375 5.18125 271.483 4.91406 271.698 4.69844C271.914 4.48281 272.181 4.375 272.5 4.375H273.625C274.806 4.375 275.95 4.60469 277.056 5.06406C278.163 5.52344 279.138 6.175 279.981 7.01875C280.562 7.6 281.045 8.2375 281.43 8.93125C281.814 9.625 282.109 10.3656 282.316 11.1531C282.409 11.0219 282.512 10.8953 282.625 10.7734C282.738 10.6516 282.859 10.525 282.991 10.3937C283.834 9.55 284.809 8.89844 285.916 8.43906C287.022 7.97969 288.175 7.75 289.375 7.75H290.5C290.819 7.75 291.086 7.85781 291.302 8.07344C291.517 8.28906 291.625 8.55625 291.625 8.875V10C291.625 11.2 291.395 12.3531 290.936 13.4594C290.477 14.5656 289.825 15.5406 288.981 16.3844C288.138 17.2281 287.167 17.875 286.07 18.325C284.973 18.775 283.825 19 282.625 19V23.5C282.625 23.8188 282.517 24.0859 282.302 24.3016C282.086 24.5172 281.819 24.625 281.5 24.625Z",
    fill: "#1EB65B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonation);
export default __webpack_public_path__ + "static/media/donation.78e43c5186fede01f59cbd2880b25d20.svg";
export { ForwardRef as ReactComponent };